import React from 'react';
import {withTranslation} from 'react-i18next';

class RenderListColors extends React.Component<any, any> {
  private selected: string;
  constructor(props: any) {
    super(props);
    this.selected = '';
    this.state = {
      modelSelected : ''
    };

    this.handleOnColorClick = this.handleOnColorClick.bind(this);
  }

  private handleOnColorClick(color: any, index: number) {
    this.selected = color.nom;
    this.setState({modelSelected : color.nom})
    this.props.onColorClick(color.id, index);
  }

  private modelHover(color: any, index: number) {
    this.setState({modelSelected : color.nom})
  }

  private modelLeave(color: any, index: number) {
    this.setState({modelSelected : this.selected})
  }

  render() {
    const colorSelected = () => {
      const type = this.state.modelSelected == '' ? this.selected : this.state.modelSelected ;
      return (
        <>
          <span className={'text-capitalize'}>
            {this.props.t('model')} :</span>

        <span className={'bold pl-2'}>{type}</span>
        </>
      )
    }
    const colorCards = this.props.couleurs.map((elt: any,index: any) => {
      const isActive = elt.id === this.props.idColorSelected;
      const isHover = elt.nom === this.state.modelSelected;
      if(isActive) {
        this.selected = elt.nom;
      }
      if(elt && elt.id) {
        const useImg = this.props?.resolutionsMin && elt.img && elt.img[this.props.resolutionsMin] && typeof elt.img[this.props.resolutionsMin][0] !== 'undefined';
        return (
          <div key={elt.id}
               onClick={() => this.handleOnColorClick(elt, index)} onMouseEnter={() => this.modelHover(elt, index)}  onMouseLeave={() => this.modelLeave(elt, index)}
               className={`cursor-pointer colorOption p-2 mr-3 mb-3  border border-2 ${(isActive || isHover) ? 'border-dark-dt' : ''}`} 
               id={'color-' + elt.id}>
            {useImg ? (
            <img src={elt.img[this.props.resolutionsMin][0]} style={{height: '50px'}} alt={this.props.titleProduct + ' ' +elt.nom}/>
            ) : (
              <div style={{backgroundColor: '#'+elt.code1, width: '50px', height: '50px'}}>&nbsp;</div>
            )}
          </div>
        );
      }
    });

    return (
        <div>
          <div className={'d-flex flex-wrap'}>
            {colorCards}
          </div>
          <div className={'font14 mt-2'}>
          {colorSelected()}
          </div>
        </div>
    );
  }
}

export default withTranslation('common')(RenderListColors);
